import { InvoiceVersionDto } from '@api';

export const INVOICE_VERSIONS: InvoiceVersionDto[] = [];
